<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Job Logs
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="filteredHeaders"
            :items="items"
            hide-actions
            :loading="logListLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.createdDate | formatDate }}</td>
                <td class="text-xs-right" v-if="$auth.user().AuthScope.includes('job:manage')">
                  <v-tooltip bottom color="accent">
                    <v-icon
                      color="accent"
                      slot="activator"
                      @click="configDialog = true; configItems = mapItems(props.item.config); datasetItems = mapItems(props.item.datasetInfo);
                              labelItems = mapItems(props.item.labelStats);"
                    >
                      list_alt
                    </v-icon>
                    <span>Show Config</span>
                  </v-tooltip>
                  <v-tooltip bottom color="accent" v-if="$auth.user().AuthScope.includes('topic:manage') && [3, 4].includes(job.type)">
                    <v-icon
                      class="mr-2"
                      color="accent"
                      slot="activator"
                      @click="$router.push(`/scheduled-jobs/${id}/logs/${props.item.id}/experiment-logs`)"
                    >
                      view_headline
                    </v-icon>
                    <span>Show Logs</span>
                  </v-tooltip>
                  <v-tooltip bottom color="accent" v-if="$auth.user().AuthScope.includes('topic:manage') && [1, 2].includes(job.type)">
                    <v-icon
                      class="mr-2"
                      color="accent"
                      slot="activator"
                      @click="$router.push(`/scheduled-jobs/${id}/logs/${props.item.id}/scoring-logs`)"
                    >
                      view_headline
                    </v-icon>
                    <span>Show Logs</span>
                  </v-tooltip>
                  <v-tooltip bottom color="error">
                    <v-icon
                      color="error"
                      slot="activator"
                      @click="dialog = true; itemToDelete = props.item;"
                    >
                      delete
                    </v-icon>
                    <span>Delete Item</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" flat depressed @click.native="cancel" >Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
          v-model="dialog"
          max-width="500"
          v-if="$auth.user().AuthScope.includes('job:manage')"
        >
          <v-card>
            <v-card-title class="headline">Delete log</v-card-title>
            <v-card-text>
              Are you sure to delete this log?
            </v-card-text>
            <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
              <v-spacer></v-spacer>
              <v-btn
                color="grey darken-1"
                flat
                depressed
                :disabled="deleteLoading"
                @click="dialog = false; itemToDelete = {};"
              >
                Cancel
              </v-btn>
              <v-btn
                color="error"
                depressed
                class="white--text"
                :loading="deleteLoading"
                :disabled="deleteLoading"
                @click.native="deleteItem()"
              >
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    <v-dialog
      v-model="configDialog"
      persistent
      scrollable
      width="800"
      >
        <v-card>
          <v-card-title primary-title class="primary white--text headline">Configs</v-card-title>
              <v-tabs
              grow
              icons-and-text
              dark
              slider-color="grey lighten-4"
              color="primary"
              v-model="step">
                <v-tab ripple>
                  Config
                </v-tab>
                <v-tab ripple>
                  Dataset Info
                </v-tab>
                <v-tab ripple>
                  Labels
                </v-tab>
              </v-tabs>
              <v-card-text>
                <v-tabs-items v-model="step">
                  <v-tab-item class="mt-4">
                    <v-data-table
                    hide-actions
                    :headers="configHeaders"
                    :items="configItems">
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.name}}</td>
                        <td>{{ props.item.value}}</td>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item class="mt-4">
                    <v-data-table
                    hide-actions
                    :headers="datasetHeaders"
                    :items="datasetItems">
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.name}}</td>
                        <td>{{ props.item.value}}</td>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item class="mt-4">
                    <v-data-table
                    hide-actions
                    :headers="labelHeaders"
                    :items="labelItems">
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.name}}</td>
                        <td>{{ props.item.value}}</td>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            flat
            depressed
            @click="configItems = []; configDialog = false;"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    id: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      headers: [
        {text: 'ID', sortable: true, value: 'id'},
        {text: 'Created Date', sortable: true, value: 'createdDate'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ],
      configHeaders: [
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Value', sortable: false, value: 'value'}
      ],
      datasetHeaders: [
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Value', sortable: false, value: 'value'}
      ],
      labelHeaders: [
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Value', sortable: false, value: 'value'}
      ],
      items: [],
      configItems: [],
      datasetItems: [],
      labelItems: [],
      dialog: false,
      logsDialog: false,
      itemToDelete: {},
      itemToFetch: {},
      logsToShow: [],
      step: 0,
      deleteLoading: false,
      logListLoading: false,
      pagination: {
        sortBy: 'id'
      },
      job: {}
    }
  },
  computed: {
    filteredHeaders () {
      if (!this.$auth.user().AuthScope.includes('job:manage')) {
        return this.headers.slice(0, 4)
      }
      return this.headers
    }
  },
  created () {
    this.logListLoading = true
    this.fetchScheduledJobItem()
    this.fetchLogs()
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    fetchScheduledJobItem () {
      this.axios.get(`/jobs/${this.id}`)
        .then(response => {
          var item = response.data
          this.job = {
            id: item.id,
            type: item.job_type,
          }
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    fetchLogs () {
      this.axios.get(`/jobs/${this.id}/logs`)
        .then(response => {
          response.data.forEach(jobLog => {
            this.items.push({
              id: jobLog.id,
              config: jobLog.config,
              datasetInfo: jobLog.dataset_info,
              labelStats: jobLog.label_stats,
              createdDate: jobLog.created_date,
              file: jobLog.file
            })
          })
        })
        .catch(error => {
          console.log(error)
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.logListLoading = false
        })
    },
    deleteItem () {
      this.deleteLoading = true
      this.axios.delete(`/jobs/${this.id}/logs/${this.itemToDelete.id}`)
        .then(response => {
          let index = this.items.indexOf(this.itemToDelete)
          this.items.splice(index, 1)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.deleteLoading = false
          this.dialog = false
          this.itemToDelete = {}
        })
    },
    mapItems (item) {
      var res = []
      for (var key in item) {
        res.push({
          name: key,
          value: item[key]
        })
      }
      return res
    },
    ...mapActions({
      setLoader: 'loader/setLoader'
    })
  }
}
</script>

<style>

</style>
